"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECustomerStatus = void 0;
const class_validator_1 = require("class-validator");
const Contact_1 = __importDefault(require("./Contact"));
const Document_1 = __importDefault(require("./Document"));
const OfficeFolder_1 = __importDefault(require("./OfficeFolder"));
const Resource_1 = __importDefault(require("../Resource"));
const classTransformer_1 = require("../classTransformer");
const TotpCodes_1 = __importDefault(require("./TotpCodes"));
const Office_1 = __importDefault(require("./Office"));
const Note_1 = __importDefault(require("./Note"));
class Customer extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.created_at = null;
        this.updated_at = null;
    }
}
exports.default = Customer;
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], Customer.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], Customer.prototype, "status", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => Contact_1.default),
    __metadata("design:type", Contact_1.default)
], Customer.prototype, "contact", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], Customer.prototype, "created_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], Customer.prototype, "updated_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], Customer.prototype, "deleted_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Object)
], Customer.prototype, "deleted_by_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => OfficeFolder_1.default),
    __metadata("design:type", Array)
], Customer.prototype, "office_folders", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => Document_1.default),
    __metadata("design:type", Array)
], Customer.prototype, "documents", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => TotpCodes_1.default),
    __metadata("design:type", Array)
], Customer.prototype, "totpCodes", void 0);
__decorate([
    (0, classTransformer_1.Exclude)(),
    __metadata("design:type", Object)
], Customer.prototype, "password", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => Office_1.default),
    __metadata("design:type", Office_1.default)
], Customer.prototype, "office", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => Note_1.default),
    __metadata("design:type", Array)
], Customer.prototype, "notes", void 0);
var ECustomerStatus;
(function (ECustomerStatus) {
    ECustomerStatus["VALIDATED"] = "VALIDATED";
    ECustomerStatus["PENDING"] = "PENDING";
    ECustomerStatus["ERRONED"] = "ERRONED";
})(ECustomerStatus || (exports.ECustomerStatus = ECustomerStatus = {}));
